import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  flex50: {
    flex: 0.5,
  },
}));
